export default __webpack_public_path__ + "abf0fed1d2e17a8618db303c7ff786b8.svg";